/**
 * Anti-copy & anti-inspect protection for R.E.Mobiles
 * Disables: right-click, text selection, keyboard shortcuts, DevTools detection
 * Admins and super_admins are exempt via window.__ADMIN_MODE__
 */

const BLOCKED_KEYS = [
  { ctrl: true, key: 'u' },        // View source
  { ctrl: true, key: 's' },        // Save page
  { ctrl: true, key: 'c' },        // Copy
  { ctrl: true, key: 'a' },        // Select all
  { ctrl: true, shift: true, key: 'i' }, // DevTools
  { ctrl: true, shift: true, key: 'j' }, // Console
  { ctrl: true, shift: true, key: 'c' }, // Inspect element
  { key: 'F12' },                   // DevTools
];

let devToolsAlerted = false;

function initProtection() {
  // Phase 2.5: ensure global copy/cut blocker is active.
  try { initClipboardLock(); } catch (_) {}

  // 1. Disable right-click (skipped for admins)
  document.addEventListener('contextmenu', (e) => {
    if (window.__ADMIN_MODE__) return;
    e.preventDefault();
    return false;
  });

  // 2. Disable text selection via CSS (admin-mode class overrides)
  const style = document.createElement('style');
  style.textContent = `
    body:not(.admin-mode) , body:not(.admin-mode) * {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
    body.admin-mode, body.admin-mode * {
      -webkit-user-select: auto !important;
      -moz-user-select: auto !important;
      -ms-user-select: auto !important;
      user-select: auto !important;
    }
    input, textarea, [contenteditable="true"], .allow-select {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
    }
  `;
  document.head.appendChild(style);

  // 3. Block keyboard shortcuts (skipped for admins)
  document.addEventListener('keydown', (e) => {
    if (window.__ADMIN_MODE__) return;
    for (const combo of BLOCKED_KEYS) {
      const ctrlMatch = combo.ctrl ? (e.ctrlKey || e.metaKey) : true;
      const shiftMatch = combo.shift ? e.shiftKey : !e.shiftKey || !combo.shift;
      const keyMatch = e.key === combo.key || e.key === combo.key.toLowerCase();
      
      if (ctrlMatch && shiftMatch && keyMatch) {
        if (combo.key === 'c' && !combo.shift && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }
  });

  // 4. Disable drag (skipped for admins)
  document.addEventListener('dragstart', (e) => {
    if (window.__ADMIN_MODE__) return;
    e.preventDefault();
    return false;
  });

  // 5. DevTools detection
  let devToolsOpen = false;
  const threshold = 160;
  const checkDevTools = () => {
    const widthDiff = window.outerWidth - window.innerWidth > threshold;
    const heightDiff = window.outerHeight - window.innerHeight > threshold;
    if (widthDiff || heightDiff) {
      if (!devToolsOpen) {
        devToolsOpen = true;
        if (!devToolsAlerted) {
          devToolsAlerted = true;
          console.clear();
          console.log('%c⚠️ ATTENTION', 'color: red; font-size: 40px; font-weight: bold;');
          console.log('%cCe site est protégé. Toute tentative de copie ou de reverse engineering est interdite et surveillée.', 'color: white; font-size: 16px; background: #333; padding: 10px;');
        }
      }
    } else {
      devToolsOpen = false;
    }
  };
  setInterval(checkDevTools, 1000);

  // 6. Disable console in production
  if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    console.table = noop;
    console.dir = noop;
  }

  // 7. Disable print (skipped for admins)
  window.addEventListener('beforeprint', (e) => {
    if (window.__ADMIN_MODE__) return;
    e.preventDefault();
    document.body.style.display = 'none';
  });
  window.addEventListener('afterprint', () => {
    document.body.style.display = '';
  });

  // 8. Prevent iframe embedding
  if (window.self !== window.top) {
    try {
      const hostname = window.location.hostname;
      if (hostname === 'remobiles.com' || hostname === 'www.remobiles.com') {
        window.top.location = window.self.location;
      }
    } catch (e) {}
  }
}

/**
 * Enable admin mode: disables all copy/select/right-click restrictions.
 */
export function enableAdminMode() {
  window.__ADMIN_MODE__ = true;
  document.body.classList.add('admin-mode');
}

/**
 * Disable admin mode: re-enables all protections.
 */
export function disableAdminMode() {
  window.__ADMIN_MODE__ = false;
  document.body.classList.remove('admin-mode');
}


// ═══════════════════════════════════════════
// Phase 2.5 — Clipboard lock + audit logging
// ═══════════════════════════════════════════
let _clipboardLockInited = false;
let _lastReportedAt = 0;

function _reportClipboardBlock(action) {
  // Throttle: max 1 audit ping every 5s to avoid flooding
  const now = Date.now();
  if (now - _lastReportedAt < 5000) return;
  _lastReportedAt = now;
  try {
    const token = localStorage.getItem('token') || '';
    const path = (window.location && window.location.pathname) || '';
    const apiUrl = process.env.REACT_APP_BACKEND_URL || '';
    const url = apiUrl + '/api/audit/clipboard-block';
    fetch(url, {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ action, path }),
    }).catch(() => {});
  } catch (_) { /* silent */ }
}

/**
 * Phase 2.5 — Initialize global copy/cut blocker. Idempotent.
 * Listens BEFORE any per-page handler so paste remains free for inputs.
 */
export function initClipboardLock() {
  if (_clipboardLockInited) return;
  _clipboardLockInited = true;

  const blockClipboard = (e) => {
    // Carlos super-admin bypass via flag set by AuthContext
    if (window.__ADMIN_MODE__) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.clipboardData) {
      try { e.clipboardData.setData('text/plain', ''); } catch (_) {}
    }
    _reportClipboardBlock(e.type);
    return false;
  };

  document.addEventListener('copy', blockClipboard, true);
  document.addEventListener('cut', blockClipboard, true);
  // contextmenu déjà géré par initProtection — on n'ajoute rien.
}


export default initProtection;
